import { BannerThemeOption } from '@helpers/brand';
import { withBaseProps } from '@hoc/withBaseProps';
import SvgSpeechBubble from '@img/icons/speech-bubble.svg';
import { ButtonType } from '@stories/Components/Buttons/Button/ButtonType';
import CallButton from '@stories/Components/Buttons/CallButton/CallButton';
import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
import Accreditations from '@stories/Components/Misc/Accreditations/Accreditations';
import SectionLinks from '@stories/Components/Misc/SectionLinks/SectionLinks';
import TrustpilotBlock from '@stories/Components/Misc/TrustpilotBlock/TrustpilotBlock';
import React from 'react';
import S from '../InnerHeroBanner.styles';
const VariantLinks = (props) => {
    const contactCtaTheme = props.theme === BannerThemeOption.DarkCoral || props.theme === BannerThemeOption.GreenDark
        ? 'light'
        : 'dark';
    return (React.createElement(React.Fragment, null,
        React.createElement(S.ContentColumn, null,
            React.createElement(S.Title, null, props.title),
            props.titleSupportingText && (React.createElement(S.TitleSupportingText, null, props.titleSupportingText)),
            props.content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.content } }),
            React.createElement(S.RowContainer, null,
                props.cta && (React.createElement(LinkButton, { href: props.cta.url, target: props.cta.target ?? '_self', buttonType: ButtonType.Default, icon: React.createElement(SvgSpeechBubble, null) }, props.cta.text)),
                props.contactCta && (React.createElement(S.ContactWrapper, { "data-cta-theme": contactCtaTheme },
                    React.createElement(CallButton, { ...props.contactCta }))))),
        React.createElement(S.LinksColumn, null,
            props.sectionLinks && React.createElement(SectionLinks, { ...props.sectionLinks }),
            props.accreditations && React.createElement(Accreditations, { size: 'large', ...props.accreditations }),
            props.trustpilot && React.createElement(TrustpilotBlock, { ...props.trustpilot }))));
};
export default withBaseProps(VariantLinks);
